import React, {useCallback, useEffect, useState} from "react";
import {Card, Col, Container, Form, ListGroup, Row} from "react-bootstrap";
import ErrorToast from "../common/ErrorToast"
import SuccessToast from "../common/SuccessToast"
import cloneDeep from "lodash/cloneDeep";
import {useDispatch, useSelector} from "react-redux";
import {getAllPayers} from "../../actions/admin/practiceInformationActions";
import {EQHSpinner} from "../../components/EQHSpinner";
import {Typeahead} from "react-bootstrap-typeahead";

const componentName = "PracticeInformation";
const isEmpty = require("is-empty");

export const PracticeLevelConfiguration = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ practiceLevel: {}, orgArray: [] });
  const [isLoading, setLoading] = useState(false);
  const { allOrganizations } = useSelector((state) => state.practiceInformation);
  const errors = useSelector((state) => state.errors);
  const success = useSelector(state => state.success);
  const [practiceLevel, setPracticeLevel] = useState({});
  const [selectedPractice, setSelectedPractice] = useState([]);
  const [practiceFilterApplied, setPracticeFilterApplied] = useState(false);
  const [statusFilter, setStatusFilter] = useState(false);

  const handleChangeDropDown = (e) => {
    const { value } = e.target;
    mapData(value);
    setPracticeLevel(value);
    setPracticeFilterApplied(false);
    setStatusFilter(true);
    if(value === "") {
      setStatusFilter(false);
    }
  };

  const handleChangePractice = (e) => {
    e.target = {};
    e.target.name = "organization";
    e.target.value = e[0];
    if(e && e[0]) {
      setSelectedPractice(e[0]);
      const value = e[0].name;
      searchPracticeData(value);
      const selectedPractice = e[0];
      setSelectedPractice(selectedPractice.name);
      setPracticeFilterApplied(true);
      setStatusFilter(false);
      setPracticeLevel(value);
    } else if (e.length === 0) {
      setPracticeFilterApplied(false);
      setStatusFilter(false);
      setPracticeLevel("");
      setSelectedPractice("");
      const newObject = cloneDeep(allOrganizations);
      setFormData({ ...formData, orgArray: newObject });
    }
  };

  const searchPracticeData = (value) => {
    const newNewObject = []
    if (allOrganizations && allOrganizations.length) {
      const newObject = cloneDeep(allOrganizations);
      newObject.forEach(element => {
        const obj = {}
        obj.name = element.name
        // obj.id = element.id
        if (!isEmpty(element.name) && element.name === value) {
          obj.selected = true;
          obj.recentlyUnselected = false;
          obj.recentlySelected = false;
          newNewObject.push(obj)
        }
      });
      setFormData({ ...formData, practiceLevel: value, orgArray: newNewObject });
    }
    return newNewObject
  }


  const mapData = useCallback((value) => {
    const newNewObject = [];
    setPracticeFilterApplied(false);
    if (allOrganizations && allOrganizations.length) {
      const newObject = cloneDeep(allOrganizations);
      newObject.forEach(element => {
        const obj = {}
        obj.name = element.name
        obj.id = element.id
        if (!isEmpty(element.practiceLevel) && element.practiceLevel === value) {
          obj.selected = true;
          obj.recentlyUnselected = false;
          obj.recentlySelected = false;
        }
        newNewObject.push(obj)
      });
      setFormData(currentFormData => ({ ...currentFormData, practiceLevel: value, orgArray: newNewObject }));
    }    
    return newNewObject
  }, [allOrganizations])

  useEffect(() => {
    (async function fetchData() {
      setLoading(true)
      await dispatch(getAllPayers());    
    })();
  }, [dispatch]);

  useEffect(() => {    
    setLoading(false)      
    mapData(practiceLevel);
  }, [allOrganizations, mapData, practiceLevel]);

  const selectPayer = (e, val) => {
    const { checked } = e.target;
    var index = formData.orgArray.indexOf(val);
    if (checked && formData.orgArray && formData.orgArray.length) {
      formData.orgArray[index].selected = true;
      formData.orgArray[index].recentlySelected = true;
      formData.orgArray[index].recentlyUnselected = false;
    } else {
      formData.orgArray[index].selected = false;
      formData.orgArray[index].recentlySelected = false;
      formData.orgArray[index].recentlyUnselected = true;
    }
    setFormData({ ...formData, orgArray: formData.orgArray });
  };
  return (
    <Container fluid>
      <Row className="py-3">
        <Col>
          <Card>
            <Card.Body>
              <Row className="mb-3">
                <Col md={5} className="col-xxl-3">
                  <Form.Group disabled={isLoading} className="mb-3">
                    <Card.Title id={`${componentName}-payersLabel`}>Practice Level EHR connection status</Card.Title>
                    <Form.Control
                      as="select"
                      className="form-control"
                      disabled={isEmpty(allOrganizations) || practiceFilterApplied}
                      name="practiceLevel"
                      id={`${componentName}-pracLevel`}
                      // defaultValue={user.roles.length ? user.roles[0].roleName : user.roles[0].role}
                      onChange={(e) => handleChangeDropDown(e)}
                      value={practiceLevel}
                    >
                      <option value="">--Select</option>
                      <option value="integratedEHR">Integrated EHR</option>
                      <option value="noIntegration">No Integration</option>
                    </Form.Control>
                  </Form.Group>
                  <div id={`${componentName}-orLabel`} className="text-center mb-3">OR</div>
                  <Form.Group>
                    <Card.Title id={`${componentName}-practiceLabel`}>Practice Search</Card.Title>
                    <Typeahead
                        id={`${componentName}-practiceValue`}
                        inputProps={{
                          id: `${componentName}-practiceValue`
                        }}
                        clearButton={true}
                        disabled={isEmpty(allOrganizations) || statusFilter}
                        labelKey="name"
                        multiple={false}
                        positionFixed={true}
                        flip={true}
                        onChange={(e) => handleChangePractice(e)}
                        options={allOrganizations}
                        placeholder="Search for a practice"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  {isLoading && <EQHSpinner />}{" "}
                  <Form>
                    <Card.Title id={`${componentName}-payersLabel`}>Participating Practices</Card.Title>
                    <ListGroup className="mh-300 overflow-y-auto border" variant="flush">
                      {formData.orgArray &&
                        formData.orgArray.length > 0 &&
                        formData.orgArray.map((val) => (
                            ((isEmpty(practiceLevel) && isEmpty(selectedPractice)) || val.selected) && (<ListGroup.Item>
                              <span id={`${componentName}-${val.name}Value`} name={val.name} onChange={(e) => selectPayer(e, val)} disabled={isEmpty(practiceLevel) || isLoading} />
                              <span id={`${componentName}-${val.id}Label`}>{val.name}</span>
                          </ListGroup.Item>)
                        ))}
                    </ListGroup>
                  </Form>
                </Col>
              </Row>
              {errors && errors.message && <ErrorToast />}
              {success && success.message && <SuccessToast />}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PracticeLevelConfiguration;
